// extracted by mini-css-extract-plugin
export default {"section":"userSearchResult_section__xEDWY","container":"userSearchResult_container__0Lu0o","user_not_found_msg":"userSearchResult_user_not_found_msg__1XeTo"};